import React from "react";
import { SiMicrosoftedge } from "react-icons/si";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaBehance } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";

const socialLinksData = [
  {
    id: 1,
    icon: <SiMicrosoftedge />,
    path: "https://dev-ah.com",
  },
  {
    id: 2,
    icon: <FaFacebookF />,
    path: "https://www.facebook.com/A7med.raheem",
  },
  {
    id: 3,
    icon: <FaLinkedinIn />,
    path: "https://www.linkedin.com/in/ahmedraheem",
  },
  {
    id: 4,
    icon: <FaBehance />,
    path: "https://www.behance.net/ahmed-raheem",
  },
  {
    id: 5,
    icon: <FaYoutube />,
    path: "https://www.youtube.com/channel/UC8Ize_6qjiZOeD1lZ-wUStQ",
  },
];

export default socialLinksData;
